export default __webpack_public_path__ + "static/media/security.77dd0ee9.png";